import { Component, EventEmitter, Input,  OnInit, Output, ViewChild } from '@angular/core';
import {  NgForm } from '@angular/forms';
import { SharedDataService } from '../../Services/shared-data/shared-data.service';
import { Agency } from '../../Models/Agency';


@Component({
  selector: 'agency-row',
  templateUrl: './agency-row.component.html',
  styleUrls: ['./agency-row.component.scss']
})
export class AgencyRowComponent implements OnInit {

  @ViewChild('frmAgency')
  public frmAgency : NgForm;

  @Input() readonly: boolean = false;
  @Input() canDelete: boolean = false;
  @Input() canAdd: boolean = false;
  @Input() agency : Agency = new Agency();
  @Output() delete : EventEmitter<Agency> = new EventEmitter<Agency>();
  @Output() add : EventEmitter<Agency> = new EventEmitter<Agency>();

  constructor(private sharedDataSvc: SharedDataService) { }

  ngOnInit(): void {
    //console.log('AgencyRowComponent.ngOnInit()');
  }
  onDelete():void{
    if (this.agency) this.delete.emit(this.agency);
  }
  onAdd():void{
    if (this.sharedDataSvc.CanSave(this.frmAgency)){
      this.add.emit(this.agency);
    }
  }

}
